import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import Escalations from "../Escalations/Escalations";
import { useUser } from "../../../lib/context/UserContext";
import CommonFilters from "../../../components/CommonFilters";
import { MonthRangePicker } from "../../../components/ui/monthrangepicker";
import { pastFinancialdate } from "../../../lib/Misc";
import { useMediaQuery } from "../../../components/use-media-query";

const tabsKey = [
  {
    name: "Contact Hub Escalation",
    tabName: "contact-escalations",
    value: 1,
  },
  {
    name: "Reports & Incidents",
    tabName: "report-escalations",
    value: 2,
  },
];

const EscalationTabs = ({
  dashboard = false,
  initalAmlDashboardValue = "all",
  selectedMonthRangeDashboard = false,
}) => {
  const location = useLocation();
  const isDesktop = useMediaQuery("(min-width: 768px)");

  const query = new URLSearchParams(location.search);
  const { permission } = useUser();

  const fromMonth = query.get("from")
    ? new Date(
        `${query.get("from")?.split("-")[1]}-${
          query.get("from")?.split("-")[0]
        }-01`,
      )
    : "";
  const toMonth = query.get("to")
    ? new Date(
        `${query.get("to")?.split("-")[1]}-${query.get("to")?.split("-")[0]}-01`,
      )
    : "";

  const [selectedMonthRange, setSelectedMonthRange] = React.useState(
    selectedMonthRangeDashboard
      ? selectedMonthRangeDashboard
      : fromMonth && toMonth
        ? {
            start: fromMonth,
            end: toMonth,
          }
        : {
            start: pastFinancialdate[0],
            end: pastFinancialdate[1],
          },
  );

  useEffect(() => {
    if(selectedMonthRangeDashboard) {
      setSelectedMonthRange(selectedMonthRangeDashboard)
    }
  },[selectedMonthRangeDashboard])

  const selectedTab = dashboard
    ? query.get("subChildTab")
      ? query.get("subChildTab")
      : "contact-escalations"
    : query.get("childTab")
      ? query.get("childTab")
      : "contact-escalations";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(
    defaultActiveKey ? defaultActiveKey : 1,
  );
  const [amlDashboardValue, setAmlDashboardValue] = useState(
    initalAmlDashboardValue,
  );

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        mainClassName="w-[calc(100%-3rem)]"
        actionContentDirect={true}
        actionClassName={"!mb-0"}
        actionContent={
          <div className="flex items-center gap-2 absolute top-4 right-4">
            {dashboard ? (
              <></>
            ) : (
              <>
                <MonthRangePicker
                  onMonthRangeSelect={setSelectedMonthRange}
                  selectedMonthRange={selectedMonthRange}
                  variant="outline"
                  align={isDesktop ? "end" : "start"}
                  maxDate={new Date()}
                />
                <CommonFilters
                  amlDashboardFilter={true}
                  setAmlDashboardValue={setAmlDashboardValue}
                  amlDashboardValue={amlDashboardValue}
                />
              </>
            )}
          </div>
        }
        innerBody={true}
        parentHeight={true}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative sm:max-h-[630px] overflow-auto`}
        >
          {activeTab === 1 ? (
            <Escalations
              dashboard={dashboard}
              selectedMonthRange={selectedMonthRange}
              amlDashboardValue={amlDashboardValue}
              escalationType="contact-escalations"
              readAccess={permission?.["escalations"]?.read}
              writeAccess={permission?.["escalations"]?.write}
            />
          ) : activeTab === 2 ? (
            <Escalations
              dashboard={dashboard}
              selectedMonthRange={selectedMonthRange}
              amlDashboardValue={amlDashboardValue}
              escalationType="report-escalations"
              readAccess={permission?.["escalations"]?.read}
              writeAccess={permission?.["escalations"]?.write}
            />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default EscalationTabs;
